import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from './users/services/user.service';
import { CONFIG } from '../environments/config';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private location: Location,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const { features } = CONFIG;
    this.userService.isAdmin().then((isAdmin: boolean) => {
      if (isAdmin && features.redirectAdmin && !this.isDeepLink()) {
        this.router.navigate(['/admin/dashboard']);
      }
    });
  }

  private isDeepLink(): boolean {
    const isLectureLink = /^.*\/lectures\/lect\/.*/g.test(this.location.path());
    const isCompleteLink = /^.*\/lectures\/complete\/.*/g.test(this.location.path());
    const isProfileLink = /^.*\/profile\/.*/g.test(this.location.path());

    return isLectureLink || isProfileLink || isCompleteLink;
  }

  private isSubmitLectures(): boolean {
    const isSubmit = /^.*\/submit-lecture-.*/g.test(this.location.path());

    return isSubmit;
  }
}
